export const PORTALUSERS_GET = 'PORTALUSERS_GET';
export const PORTALUSER_GET = 'PORTALUSER_GET';
export const PORTALUSER_CLASSYEARS_GET = 'PORTALUSER_CLASSYEARS_GET';
export const PORTALUSER_EDIT = 'PORTALUSER_EDIT';
export const PORTALUSER_DELETE = 'PORTALUSER_DELETE';
export const PORTALUSER_ORTU_DELETE = 'PORTALUSER_ORTU_DELETE';
export const PORTALUSER_SYNC = 'PORTALUSER_SYNC';
export const PORTALUSER_VAL_DATA = 'PORTALUSER_VAL_DATA';
